/**
 * @param {string} input
 * @returns {string}
 */
export function formatUS(input) {
  const chars = prepare(input);
  let formatted = '';
  for (let i = 0; i < chars.length; i++) {
    const char = chars.charAt(i);

    // Skip whitespace.
    if (char === ' ') {
      continue;
    }
    if (formatted.length === 0) {
      // Insert a left paren before the area code.
      formatted += '(';
    } else if (formatted.length === 4) {
      // Insert a right paren and a space after the third digit.
      // (###
      //     ^
      formatted += ') ';
    } else if (formatted.length === 9) {
      // Insert a dash after the sixth digit.
      // (###) ###
      //          ^
      formatted += '-';
    }

    // We know the character is a digit at this point.
    formatted += char;

    // Once we reach 14 characters (10 digits), the format is complete.
    if (formatted.length === 14) {
      break;
    }
  }
  return formatted;
}

/**
 * @param {string} input
 * @param {object} [options={}]
 */
export function formatIntl(input) {
  let {
    allowSpaceAfterCountryCode = false
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const chars = prepare(input);
  let formatted = '';
  let hasSeenDigit = false;
  let hasTakenSpace = false;
  for (let i = 0; i < chars.length; i++) {
    const char = chars.charAt(i);
    if (char === ' ') {
      // If no space is allowed after the country code, skip all spaces.
      if (!allowSpaceAfterCountryCode) {
        continue;
      }

      // At the beginning of the input, or after we've already accepted
      // one space, skip spaces as well.
      if (!hasSeenDigit || hasTakenSpace) {
        continue;
      }

      // At this point, we know:
      //
      // a) char is a space;
      // b) it's preceded by at least one digit; and
      // c) we haven't accepted any other spaces yet.
      //
      // This is the only space we'll allow, so set this flag for the
      // following iterations.
      hasTakenSpace = true;
    } else {
      hasSeenDigit = true;
    }
    if (formatted.length === 0) {
      // Add a leading plus sign.
      formatted += '+';
    }
    formatted += char;

    // Once we reach 16 characters w/o a space (15 digits) or 17 characters
    // with a space, the format is complete.
    if (formatted.length === (hasTakenSpace ? 17 : 16)) {
      break;
    }
  }
  return formatted;
}

/**
 * Prepare the `input` string for formatting. This removes all characters except
 * digits and spaces.
 * @param {string} input
 * @returns {string}
 */
function prepare(input) {
  return input.replace(/[^\d ]+/g, '');
}